import { Empty, Spin } from 'antd';
import { ChevronRightIcon } from '@/assets/icons/icons';
import type { CommonTasksProps } from '../../types';
import styles from '../../AppHelpCenter.module.scss';
import CommonTaskCard from '../CommonTaskCard/CommonTaskCard';

// Data is fetched by HelpCenterPanel so it survives leaving and returning to Home.
const CommonTasks = ({
  data,
  loading,
  seeAll,
  onToggleSeeAll,
  onSelect,
}: CommonTasksProps) => {
  return (
    <section className={styles.commonTasks}>
      <div className={styles.commonTasksHeader}>
        <div className={styles.commonTasksHeading}>
          <span className={styles.commonTasksLabel}>Common tasks</span>
          {data?.label && (
            <>
              <span className={styles.commonTasksQualifierIcon}>
                <ChevronRightIcon width={16} height={16} fill='currentColor' />
              </span>
              <span className={styles.commonTasksQualifier}>{data?.label}</span>
            </>
          )}
        </div>

        {(data?.has_more || seeAll) && (
          <button
            type='button'
            className={styles.commonTasksSeeAll}
            onClick={onToggleSeeAll}
          >
            {seeAll ? 'See fewer' : 'See all →'}
          </button>
        )}
      </div>

      {loading ? (
        <div className={styles.helpSectionLoading}>
          <Spin />
        </div>
      ) : !data?.tasks?.length ? (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
      ) : (
        <div className={styles.commonTasksList}>
          {data.tasks.map((task) => (
            <CommonTaskCard key={task?.id} task={task} onSelect={onSelect} />
          ))}
        </div>
      )}
    </section>
  );
};

export default CommonTasks;
